import {
  Component,
  ChangeDetectionStrategy,
  OnDestroy,
  OnInit,
} from '@angular/core';
import { TranslationService } from './modules/i18n/translation.service';
// language list
//import { locale as enLang } from './modules/i18n/vocabs/en';
import { locale as enLang } from './modules/i18n/vocabs/es'; 
import { SplashScreenService } from './_metronic/partials/layout/splash-screen/splash-screen.service';
import { Router, NavigationEnd, NavigationError } from '@angular/router';
import { Subscription } from 'rxjs';
import { TableExtendedService } from './_metronic/shared/crud-table';
import { environment } from '../environments/environment';
import { HelperServices } from '../app/pages/_services/helper.services';
import { Config } from '../app/pages/_models/config.model';
import { LayoutService } from '../app/_metronic/core/';

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'body[root]',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppComponent implements OnInit, OnDestroy {
  private unsubscribe: Subscription[] = []; // Read more: => https://brianflove.com/2016/12/11/anguar-2-unsubscribe-observables/
  private params: Config;

  constructor(
    private translationService: TranslationService,
    private splashScreenService: SplashScreenService,
    private router: Router,
    private tableService: TableExtendedService,
    private layout: LayoutService,
    private helperServices: HelperServices
    
  ) {
    // register translations
    this.translationService.loadTranslations(
      enLang,
      //chLang,
      //esLang,
      //jpLang,
      //deLang,
      //frLang
    );
  }

  async ngOnInit() {
    document.documentElement.lang = navigator.language;
    const routerSubscription = this.router.events.subscribe(async (event) => {
      if (event instanceof NavigationEnd) {
        // clear filtration paginations and others
        this.tableService.setDefaults();
        
        // hide splash screen
        this.splashScreenService.hide();

        // scroll to top on every route change
        window.scrollTo(0, 0);

        // oForzado de reload
        this.router.routeReuseStrategy.shouldReuseRoute = function(){
            return false;
        }
        
        // oForzado de reload
        this.router.events.subscribe((evt) => {
            if (evt instanceof NavigationEnd) {
            // trick the Router into believing it's last link wasn't previously loaded
            this.router.navigated = false;
            // if you need to scroll back to top, here is the right place
            window.scrollTo(0, 0);
            }
        });

        // to display back the body content
        setTimeout(() => {
          document.body.classList.add('page-loaded');
        }, 500);
      }
       
    });

    await this.helperServices.getConfig().then( x => {
      this.params = x[0];
      document.title = this.params.CompaniaAplicacion || environment.title;
      localStorage.setItem(
        "remote_params",
        JSON.stringify(this.params)
      );
    });

    this.unsubscribe.push(routerSubscription);
  }

  get p() {
    return this.params;
  }

  ngOnDestroy() {
    this.unsubscribe.forEach((sb) => sb.unsubscribe());
  }
}
